<template>
    <div class="header header-fixed justify-content-center align-items-center shadow-sm" :class='this.isMobileDevice == true? "header-mobile":""'>
        <div class="d-flex justify-content-between flex-root" :class="this.isMobileDevice == true? 'px-5 pt-5':'px-9'">
            <div class="d-flex align-items-stretch">
            <template v-if="this.isMobileDevice == true" >
                <div>
                    <b-button v-b-toggle.sidebar-1 class="btn p-0 burger-icon ml-4"
                id="header_mobile_toggle"
                ref="header_mobile_toggle"
                style="z-index:1001"
                > <span> </span></b-button>
                    <b-sidebar id="sidebar-1" bg-variant="white" text-variant="dark" shadow>
                    <div class="px-3 py-2">
                        <div id="header_menu" ref="header_menu" class="header-menu header-menu-mobile header-menu-layout-default" :class="headerMenuClasses">
                        <header-menu  />
                    </div>
                    </div>
                    </b-sidebar>
                </div>
                </template>
                <div class="d-flex align-items-center mr-10">
                    <div class="header-logo"> 
                        <router-link to="/">
                          <img id="logo" ref="logo" src="/media/svg/logos/logo.svg" :class="this.isMobileDevice == true? 'height-15':''" />
                        </router-link>
                    </div>
                </div>

                <div class="header-menu-wrapper header-menu-wrapper-left" id="header_menu_wrapper" ref="header_menu_wrapper">
                    <div id="header_menu" ref="header_menu" class="header-menu header-menu-mobile header-menu-layout-default" :class="headerMenuClasses">
                        <header-menu  />
                    </div>
                </div>
            </div>

            <top-bar />
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";

import LayoutHeader from "@/assets/js/layout/base/header.js";
import LayoutHeaderMenu from "@/assets/js/layout/base/header-menu.js";

import HeaderMenu from "@/views/layout/header/menu";
import TopBar from "@/views/layout/header/topbar";
 
export default {
    name: "Header",
    components: {
        HeaderMenu,
        TopBar
    },
    data(){
        return{
            isMobileDevice:false 
        }
    },
    created(){
        let regexp = /android|iphone|kindle|ipad/i; 
        this.isMobileDevice = regexp.test(navigator.userAgent); 
    },
    mounted() {
        LayoutHeader.init("header", "header_mobile");
        LayoutHeaderMenu.init(
            this.$refs["header_menu"],
            this.$refs["header_menu_wrapper"],
            this.$refs["logo"]
        );
    },
    computed: {
        ...mapGetters([
            "layoutConfig",
            "getClasses"
        ]),
        headerMenuClasses() {
            const classes = this.getClasses("header_menu");

            if (typeof classes !== "undefined")
                return classes.join(" ");

            return null;
        }
    }
};
</script>
<style>
.height-15{
    height:1.5rem !important;
    position:fixed !important;
    z-index: 1001;
    padding-left: 30%;
    top: 2rem;
}
.header-mobile{
    height: 6rem;
    z-index: 1000;
}
@media (max-width: 991.98px) {
    .header-mobile-fixed .topbar {
        position: fixed;
        z-index: 1000;
    }
}
</style> 
